<template>
    <div>
        <div class="col-lg-12">
            <div>
                <div class="form-group row">
                    <label class="col-sm-1 text-nowrap" style="min-width: 150px"
                        >{{ $t('landingPage.settingTargetProduct.titleBlock') }} <span class="text-danger">*</span></label
                    >
                    <div class="col-sm-10">
                        <InputText
                            :model.sync="targetProdForm.title_block"
                            :config.sync="configForm.configFieldTitleBlockTargetProduct"
                            :disabled="!!targetProdForm.title_image"
                            @blur="handleValidateField(configForm.configFieldTitleBlockTargetProduct)"
                            @change="handleShotCodeStyle"
                        />
                        <div class="mt-3">
                            <div class="form-group row">
                                <label class="col-sm-1 text-nowrap" style="min-width: 120px">{{ $t('landingPage.setSizeText') }}</label>
                                <div class="col-sm-3">
                                    <div class="d-flex align-items-center" style="gap: 0.5rem">
                                        <InputText
                                            style="max-width: 120px"
                                            :model.sync="targetProdForm.size_title"
                                            :config.sync="configForm.configFieldSizeTitle"
                                            :disabled="!!targetProdForm.title_image"
                                        />
                                        <span>px</span>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-sm-1 text-nowrap" style="min-width: 120px">{{ $t('landingPage.colorText') }}</label>
                                <div class="col-sm-5">
                                    <div class="d-flex" style="gap: 1rem">
                                        <InputText
                                            style="min-width: 100px"
                                            :model.sync="targetProdForm.color_title"
                                            :config="{
                                                type: 'color',
                                                classCustom: 'form-control-color',
                                                error: false
                                            }"
                                            :disabled="!!targetProdForm.title_image"
                                        />
                                        <InputText
                                            style="max-width: 100px"
                                            :model.sync="targetProdForm.color_title"
                                            :config="{
                                                error: false
                                            }"
                                            :disabled="!!targetProdForm.title_image"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-sm-1 text-nowrap" style="min-width: 120px">{{ $t('landingPage.backgroundText') }}</label>
                                <div class="col-sm-5">
                                    <div class="d-flex" style="gap: 1rem">
                                        <InputText
                                            style="min-width: 100px"
                                            :model.sync="targetProdForm.background_title"
                                            :config="{
                                                type: 'color',
                                                classCustom: 'form-control-color',
                                                error: false
                                            }"
                                            :disabled="!!targetProdForm.title_image"
                                        />
                                        <InputText
                                            style="max-width: 100px"
                                            :model.sync="targetProdForm.background_title"
                                            :config="{
                                                error: false
                                            }"
                                            :disabled="!!targetProdForm.title_image"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-1 text-nowrap" style="min-width: 150px">{{ $t('landingPage.settingTargetProduct.imgTitle') }}</label>
                    <div class="col-sm-10">
                        <UploadImageCommon
                            :fileValues.sync="targetProdForm.title_image"
                            :id="`TitleTargetProductImgLP`"
                            :config="{
                                maxSize: 2048
                            }"
                        >
                            <template #warning>
                                <div style="font-size: 13px">
                                    {{ $t('landingPage.noteImageBeautiful') }}
                                </div>
                            </template>
                        </UploadImageCommon>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-1 text-nowrap" style="min-width: 150px">{{ $t('landingPage.settingTargetProduct.backgroundBlock') }}</label>
                    <div class="col-sm-10">
                        <UploadImageCommon
                            :fileValues.sync="targetProdForm.background_image"
                            :id="`BackgroundImgTargetProduct`"
                            :config="{
                                maxSize: 2048
                            }"
                        >
                            <template #warning>
                                <div style="font-size: 13px">
                                    {{ $t('noteUploadMaxMB') }}
                                </div>
                            </template>
                        </UploadImageCommon>

                        <div class="form-group row mt-2">
                            <label class="col-sm-1 text-nowrap" style="min-width: 120px">{{ $t('landingPage.backgroundText') }}</label>
                            <div class="col-sm-5">
                                <div class="d-flex" style="gap: 1rem">
                                    <InputText
                                        style="min-width: 100px"
                                        :model.sync="targetProdForm.background_color"
                                        :config="{
                                            type: 'color',
                                            classCustom: 'form-control-color',
                                            error: false
                                        }"
                                    />
                                    <InputText
                                        style="max-width: 100px"
                                        :model.sync="targetProdForm.background_color"
                                        :config="{
                                            error: false
                                        }"
                                    />
                                </div>
                            </div>
                        </div>

                        <div>
                            <InputCheckBox
                                :model.sync="targetProdForm.is_repeat"
                                :id="`check-repeat-background-target__product`"
                                :value="targetProdForm.is_repeat"
                                :label="`repeat`"
                            />
                        </div>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-1 text-nowrap" style="min-width: 150px">{{ $t('landingPage.settingTargetProduct.styleBlock') }} </label>
                    <div class="col-sm-10">
                        <div class="d-flex flex-wrap" style="gap: 1rem">
                            <div v-for="item in listStyleTargetProduct" :key="item.id + 's'">
                                <InputRadio
                                    class="mr-4"
                                    :model.sync="targetProdForm.style"
                                    :name="`target-product_setting-style`"
                                    :id="`target-product_setting-style-${item.id}`"
                                    :value="item"
                                    :label="item.name"
                                    @change="handleShotCodeStyle('select')"
                                />
                                <div class="mt-2" style="width: 100px; height: 80px">
                                    <img class="w-100 h-100" style="object-fit: cover" :src="item.image_preview" :alt="item.image_preview" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="card mt-5">
                    <div class="text-right mb-5">
                        <button type="button" class="btn btn-outline-success btn-sm rounded" @click="handleAddProduct()">
                            <i class="fa fa-plus"></i>
                            対象商品追加
                        </button>
                    </div>
                </div>

                <Draggable
                    :list="targetProdForm.target_products"
                    ghost-class="ghost--targetProduct"
                    class="overflow-hidden"
                    @start="dragList = true"
                    @end="dragList = false"
                    @change="onHandleDrag"
                >
                    <div v-for="(itemTarget, k) in targetProdForm.target_products" :key="`product-${k}`" class="card p-2">
                        <div class="card-body position-relative border-bottom">
                            <div class="d-flex flex-row mt-3">
                                <div class="mr-3">
                                    <div class="d-flex align-items-center justify-content-center h-100">
                                        <InputCheckBox
                                            class="custom-switch"
                                            :model.sync="itemTarget.status"
                                            :id="`product-${k}`"
                                            :value="true"
                                            :label="``"
                                            @change="handleShotCodeStyle"
                                        />
                                    </div>
                                </div>
                                <div class="mr-3 col-sm-1" style="min-width: 120px">
                                    <img
                                        loading="lazy"
                                        :src="itemTarget?.image?.path"
                                        :alt="itemTarget?.image?.origin_name"
                                        class="img-fluid mx-auto d-block rounded h-100 w-100"
                                        style="object-fit: contain"
                                    />
                                </div>
                                <div>
                                    <div class="col-sm-12 p-0">
                                        <h4 v-b-tooltip.hover :title="itemTarget.title">{{ truncateText(itemTarget.title, 50) ?? '' }}</h4>
                                    </div>
                                    <div class="col-sm-12 p-0">
                                        <a target="_blank" :href="itemTarget.image?.path">{{ truncateText(itemTarget.image?.path, 300) ?? '' }} </a>
                                    </div>
                                    <div class="p-1" v-html="truncateText(itemTarget.detail, 500) ?? ''"></div>
                                </div>
                            </div>
                            <div class="position-absolute" style="top: 0; right: 0">
                                <button
                                    v-b-tooltip.hover="`${$t('btn.copy')}`"
                                    type="button"
                                    class="btn btn-outline-info btn-sm rounded-circle"
                                    style="width: 30px; height: 30px"
                                    @click="handleCopyTargetProduct(itemTarget)"
                                >
                                    <i class="fa fa-copy"></i>
                                </button>
                                <button
                                    v-b-tooltip.hover="`${$t('btn.edit')}`"
                                    type="button"
                                    class="btn btn-outline-warning btn-sm rounded-circle mx-3"
                                    style="width: 30px; height: 30px"
                                    @click="handleEditProduct(itemTarget, k)"
                                >
                                    <i class="fa fa-edit"></i>
                                </button>
                                <button
                                    v-b-tooltip.hover="`${$t('btn.delete')}`"
                                    type="button"
                                    class="btn btn-outline-danger btn-sm rounded-circle"
                                    style="width: 30px; height: 30px"
                                    @click="handleDeleteProduct(k)"
                                >
                                    <i class="fa fa-trash"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </Draggable>
            </div>

            <ModalActionProduct
                v-if="configModalActionProduct.model"
                :config="configModalActionProduct"
                :dataProducts="targetProdForm.target_products"
                :objProduct="formProduct"
                @saveDataProd="eventSaveDataProd"
            />
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import { InputText, InputCheckBox, InputRadio } from '@/components/Input';
import { validateField } from '@/utils/validate';
import { truncateText, tranferShortCode, getCurrentDateTimeFormatted } from '@/utils/format';
import { LIST_STYLE_TARGET_PRODUCT } from '../../styles';
import { configModalActionProduct } from './constants';
import { onHandleChangeTemp, mapImageDefault } from '../../handlers';
import { cloneDeep } from 'lodash';

import UploadImageCommon from '@/components/Uploads/Image/main.vue';
import Draggable from 'vuedraggable';
import ModalActionProduct from './modal-action-product.vue';

export default {
    name: 'settingTargetProduct',
    components: {
        InputText,
        InputCheckBox,
        UploadImageCommon,
        Draggable,
        ModalActionProduct,
        InputRadio
    },
    props: {
        dataForm: {
            type: Object,
            required: true,
            default: () => null
        },
        configForm: {
            type: Object,
            required: true,
            default: () => null
        }
    },
    computed: {
        ...mapState({
            ...mapState('landingPage', ['infoSettingLandingPage'])
        })
    },

    data() {
        return {
            dragList: false,
            listStyleTargetProduct: mapImageDefault(LIST_STYLE_TARGET_PRODUCT),
            configModalActionProduct: configModalActionProduct,
            formProduct: null,
            targetProdForm: cloneDeep(this.dataForm)
        };
    },
    methods: {
        truncateText,

        handleValidateField(configField) {
            validateField(configField);
        },

        onHandleDrag() {
            this.handleShotCodeStyle();
        },

        onHandleMakeId() {
            const handleMakeId =
                this.targetProdForm.target_products.length <= 0
                    ? this.targetProdForm.target_products.length + 1
                    : Math.max(...this.targetProdForm.target_products.map((item) => item.id || item.make_id)) + 1;
            return handleMakeId;
        },

        handleCopyTargetProduct(evtProd) {
            this.targetProdForm.target_products.push({
                size_product: evtProd.size_product,
                color_product: evtProd.color_product,
                background_product: evtProd.background_product,
                background_item: evtProd.background_item,
                detail: evtProd.detail,
                image: evtProd.image,
                make_id: this.onHandleMakeId(),
                status: evtProd.status,
                title: `${evtProd.title} Copy ${getCurrentDateTimeFormatted()}`
            });
            this.handleShotCodeStyle();
        },

        handleAddProduct() {
            this.formProduct = null;
            this.configModalActionProduct.model = true;
        },

        handleEditProduct(productItem) {
            this.formProduct = productItem;
            this.configModalActionProduct.model = true;
        },

        handleDeleteProduct(idx) {
            this.targetProdForm.target_products.splice(idx, 1);
            this.handleShotCodeStyle();
        },

        eventSaveDataProd(newProd) {
            const hasConfigId = newProd?.id ?? newProd.make_id;
            let indexProd = this.targetProdForm.target_products.findIndex((item) => {
                const hasIdList = item?.id ?? item.make_id;
                return hasIdList == hasConfigId;
            });
            if (indexProd <= -1) {
                this.targetProdForm.target_products.push(newProd);
            } else {
                this.targetProdForm.target_products[indexProd] = newProd;
            }
            this.handleShotCodeStyle();
        },

        handleShotCodeStyle(type = null) {
            if (!this.targetProdForm.style) return;
            let contentNew = [];
            let { contents, backgroundColorDefault } = this.targetProdForm.style;
            if (type === 'select') this.targetProdForm.background_color = backgroundColorDefault ?? '#ffffff';
            this.targetProdForm.target_products.forEach((itemTargetP) => {
                const replacements = {
                    nameTargetProduct: itemTargetP.title ?? '',
                    fontSizeProduct: itemTargetP.size_product ? `${itemTargetP.size_product}px` : '46px',
                    colorProduct: itemTargetP.color_product ?? '',
                    bgrColorProduct: itemTargetP.background_product ?? '',
                    backgroundItem: itemTargetP.background_item ?? '',
                    detailTargetProduct: itemTargetP.detail ?? '',
                    imageTargetProduct: itemTargetP?.image?.path ?? '',
                    display: itemTargetP?.status ? 'block' : 'none'
                };
                let contentShotCode = tranferShortCode(contents, replacements);
                contentNew.push(contentShotCode);
            });
            let convertContentString = contentNew.join(``);
            let addProper = this.targetProdForm.target_products?.length > 0 ? convertContentString : '';
            this.targetProdForm.html_content = addProper;
        }
    },

    watch: {
        infoSettingLandingPage: {
            handler: function (newSetting) {
                if (this.targetProdForm.style) return;
                let checkTem = onHandleChangeTemp(newSetting, this.targetProdForm, this.listStyleTargetProduct);
                if (checkTem) this.handleShotCodeStyle('select');
            },
            immediate: true,
            deep: true
        },

        dataForm: {
            handler(newDataForm) {
                this.targetProdForm = newDataForm;
            },
            immediate: true
        },

        targetProdForm: {
            handler(newTargetProdForm) {
                this.$emit('update:dataForm', newTargetProdForm);
            },
            deep: true
        }
    }
};
</script>

<style lang="scss" scoped></style>
